export default "__VITE_ASSET__mCGuJhoX__"